<template>
  <v-dialog
    v-if="!!ete"
    :value="!!ete"
    max-width="80%"
    height="100%"
    persistent
    :fullscreen="fullscreen"
    @keydown.esc="done"
    ><v-card>
      <v-card-title>
        <span class="headline">
          {{ $t("extTrainings.employees.title") }}
          {{ extTraining.id }} - {{ extTraining.name }} -
          {{ $options.filters.date(extTraining.dateTimeOfOccurrence) }}
        </span>
        <v-spacer />
        <v-btn icon @click="fullscreen = !fullscreen"
          ><v-icon>{{
            fullscreen ? "fullscreen_exit" : "fullscreen"
          }}</v-icon></v-btn
        >
        <v-btn icon @click="done"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-row justify="end" class="ma-3">
        <v-btn
          color="primary"
          :text="!showEmails"
          @click="showEmails = !showEmails"
        >
          {{
            showEmails
              ? $t("extTrainings.email.hide")
              : $t("extTrainings.email.show")
          }}
        </v-btn>

        <v-btn color="primary" class="ml-3" @click="showEmployeesSelect = true">
          {{ $t("extTrainings.employees.change") }}
        </v-btn>
      </v-row>
      <ext-training-employees-table
        :employees="filteredEmployees"
        :selectedEmployees="ete.employees.filter((e) => e.participated)"
        :tags="tags"
        :loading="loading"
        :tagCategories="tagCategories"
        @selectedChange="handleParticipatedChange"
        @filtersChange="handleFiltersChange"
        @fileChanged="addDone()"
        :showSelect="true"
        :showLastTraining="false"
        :selectedHeader="$t('extTrainings.employees.participated')"
        :showEmails="showEmails"
      />
      <ext-training-employees-add
        :show="showEmployeesSelect"
        :tags="tags"
        @done="addDone()"
        :extTraining="extTraining"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="done" :loading="loading">
          {{ $t("dialog.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="changeParticipation"
          :loading="loading"
        >
          {{ $t("dialog.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import TagCategoriesQuery from "@/graphql/TagCategories.gql";
import ExtTrainingEmployeesTable from "@/components/extTraining/ExtTrainingEmployeesTable.vue";
import ExtTrainingEmployeesAdd from "@/components/extTraining/ExtTrainingEmployeesAdd.vue";

import ChangeExtTrainingEmployeesParticipation from "@/graphql/mutation/extTraining/ChangeExtTrainingEmployeesParticipation.gql";
import TagsQuery from "@/graphql/Tags.gql";
import { createTagCategories, createEmployeesSearch } from "@/utils/common.js";

export default {
  props: ["extTraining"],
  components: {
    ExtTrainingEmployeesTable,
    ExtTrainingEmployeesAdd,
  },
  data() {
    return {
      ete: null,
      participated: [],
      filters: [],
      loading: false,
      showEmployeesSelect: false,
      fullscreen: false,
      showEmails: false,
    };
  },
  computed: {
    ...mapGetters(["role"]),
    filteredEmployees() {
      if (!this.ete.employees.length) return [];
      return this.filters.length == 0
        ? this.ete.employees
        : this.ete.employees.filter((e) => {
            const filter = e.tags.some((t) =>
              this.filters.some(
                (ft) => ft.name == t.name && ft.category == t.category
              )
            );
            return filter;
          }) || [];
    },
  },
  watch: {
    extTraining() {
      this.ete = this.extTraining;
      if (!this.extTraining) return;
      this.ete.employees = this.extTraining.employees.map((e) => {
        if (e.participated) {
          this.participated.push(e.employee);
        }
        e.employee.modes = [];
        return {
          ...e.employee,
          file: e.file,
          extTrainingEmployeeId: e.id,
          participated: e.participated,
          search: createEmployeesSearch(e.employee),
          ...createTagCategories(this.tagCategories, e.employee.tags),
        };
      });
    },
  },
  methods: {
    addDone() {
      this.$emit("refresh", this.extTraining.id);
      this.showEmployeesSelect = false;
    },
    changeParticipation() {
      const id = this.extTraining.id;
      const eIn = this.ete.employees.map((e) => {
        const participated = this.participated.some((i) => i.id == e.id);
        return {
          externalTrainingId: id,
          employeeId: e.id,
          participated,
        };
      });
      this.$apollo
        .mutate({
          mutation: ChangeExtTrainingEmployeesParticipation,
          variables: {
            id,
            eIn,
          },
        })
        .then(() => {
          this.done();
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: `Failed to change employees participation in external training ID ${id} with error: ${err}`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleFiltersChange(fc) {
      if (fc) {
        this.filters = fc;
      }
    },
    handleParticipatedChange(pc) {
      if (pc) {
        this.participated = pc;
      }
    },
    done() {
      this.showEmails = false;
      this.$emit("done");
    },
  },

  apollo: {
    tagCategories: {
      query: TagCategoriesQuery,
    },
    tags: {
      query: TagsQuery,
    },
  },
};
</script>
